import { EventEmitter } from 'events';
const _globalEvents = new EventEmitter();
const globalEvents = {
    on: _globalEvents.on,
    emit: _globalEvents.emit,
    removeListener: _globalEvents.removeListener,
};
// @ts-ignore - assign globalEvents to window to enable things like saving apollo state
window.globalEvents = globalEvents;
export { globalEvents };
//# sourceMappingURL=index.js.map